import { render } from "./DailyTransaction.vue?vue&type=template&id=6a712c29"
import script from "./DailyTransaction.vue?vue&type=script&lang=js"
export * from "./DailyTransaction.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__